module.exports = __webpack_public_path__ + "static/media/cgdl.a4f22577.mp4";